import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const UserProfilePopup = ({ isOpen, onClose, user, syncScore, onNavigateToProfile }) => {
  const { t } = useTranslation();
  if (!isOpen || !user) return null;

  return (
    <div className="modal-overlay">
      <div className="bg-gray-800 p-6 rounded-lg shadow-xl max-w-sm w-full text-white relative">
        <button onClick={onClose} className="absolute top-2 right-2 p-1 rounded-full hover:bg-gray-700">
          <LucideIcons.X size={24} />
        </button>
        <div className="flex flex-col items-center">
          <img src={user.photoURL} alt={user.displayName} className="w-24 h-24 rounded-full object-cover mb-4 border-4 border-purple-500" />
          <h3 className="text-2xl font-bold text-purple-300 font-playfair">{user.displayName}</h3>
          <p className="text-sm text-gray-400 mt-2 text-center">{user.bio || t('userProfilePopup.defaultBio')}</p>
          <div className="mt-4 w-full">
            <p className="text-center text-sm font-semibold">{t('userProfilePopup.harmonySync', { score: syncScore })}</p>
            <div className="w-full bg-gray-700/50 rounded-full h-2 mt-1">
                <div className="bg-gradient-to-r from-purple-500 to-pink-500 h-2 rounded-full" style={{ width: `${syncScore}%` }}></div>
            </div>
          </div>
          <button 
            onClick={() => { onClose(); onNavigateToProfile(user.id); }}
            className="mt-6 w-full bg-purple-600 text-white font-bold py-2 px-4 rounded-lg hover:bg-purple-700 transition-colors"
          >
            {t('userProfilePopup.viewProfileButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserProfilePopup;
